import { StrictMode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { createRoot } from 'react-dom/client';

import '@/styles/global.css';

import App from './App.tsx';
import { queryClient } from './lib/query-client.ts';
import { Toaster } from './components/ui/sonner.tsx';
import { SentryWrapper } from './components/shared/sentry-wrapper.tsx';
import { initSentry } from './config/sentry.ts';

initSentry();
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SentryWrapper>
      <QueryClientProvider client={queryClient}>
        <Toaster
          className="custom-sonner-toast"
          position="top-right"
          richColors
          closeButton={true}
        />
        <App />
      </QueryClientProvider>
    </SentryWrapper>
  </StrictMode>,
);
